import axios, { AxiosInstance  } from 'axios';

export const baseURL = process.env.NODE_ENV === 'production' && !process.env.FORCE_DEV
  ? '/rest/common'
  : 'http://localhost:3001/rest/common';

const AUTH_ID_TOKEN = 'auth.idToken';
const getItem = (key: string, dftVal?: string) => {
  if (!localStorage) return dftVal;
  return localStorage.getItem(key);
};

const storeUserIdToken = (token: string) => {
  localStorage.setItem(AUTH_ID_TOKEN, token);
};

const getUserIdToken = () => {
  const _w = window as unknown as { xprops: { tokens: { id_token: string } } };
  if (window.top == window) {
    return getItem(AUTH_ID_TOKEN);
  }
  if (!_w?.xprops) {
    return;
  }
  const tokens = _w?.xprops?.tokens || {};
  const { id_token } = tokens;
  storeUserIdToken(id_token);
  return id_token;
};

const getInstance = (header?: any): AxiosInstance =>
  axios.create({
    baseURL,
    timeout: 25000,
    headers: {
      'Content-Type': 'application/json',
      ...header,
      Authorization: `Bearer ${getUserIdToken()}`,
    },
  });

export default getInstance;
